import { render, staticRenderFns } from "./swap-cards-button.vue?vue&type=template&id=3c638877"
import script from "./swap-cards-button.vue?vue&type=script&lang=js"
export * from "./swap-cards-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports